import React from 'react';
import PropTypes from 'prop-types';
import marketplaceIcon from '../../../assets/icons/upiria_logo_Symbol_Black_white.svg';
import websiteIcon from '../../../assets/icons/id_globe_simple.svg';
import offlineIcon from '../../../assets/icons/ic_ghost.svg';
import resaleIcon from '../../../assets/icons/ic_resale.svg';

const ICONS_BY_ID = {
	1: marketplaceIcon,
	2: websiteIcon,
	3: resaleIcon,
	4: offlineIcon
};

const ID_BY_KEY = {
	marketplace: 1,
	website: 2,
	reselling: 3,
	offline: 4
};

const ChannelIcon = ({ channelId, channelKey, size = 14, alt = '', style }) => {
	const resolvedId = channelId != null ? Number(channelId) : ID_BY_KEY[channelKey];
	const src = ICONS_BY_ID[resolvedId];
	if (!src) return null;
	return (
		<img
			src={src}
			width={size}
			height={size}
			alt={alt}
			style={{ opacity: 0.6, ...style }}
		/>
	);
};

ChannelIcon.propTypes = {
	channelId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
	channelKey: PropTypes.oneOf(['marketplace', 'website', 'reselling', 'offline']),
	size: PropTypes.number,
	alt: PropTypes.string,
	style: PropTypes.object
};

export default ChannelIcon;
